<div class="modal-main">
  <div class="header w-100 pt-3">
    <div class="d-flex justify-content-between">
      <span class="col-2 d-flex flex-row align-items-center">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          alt="back button"
          class="pointer-cursor"
          (click)="navigateBack()"
        />
      </span>
      <div class="d-flex flex-column justify-content-center col-8">
        <span class="col-5 user-title m-auto text-center">
          <app-with-tooltip [showHelpCursor]="true">
            {{ this.formInstance?.name?.value }}
          </app-with-tooltip></span
        >
        <span class="modal-title m-auto">
          {{ "USER_PROFILE" | translate }}
        </span>
      </div>
      <span
        class="col-2 d-flex flex-row align-items-center justify-content-center"
      >
        <img
          src="/assets/svg/ico-hamburger-white-close.svg"
          class="cross-button pointer-cursor pr-4"
          (click)="closeDialog()"
        />
      </span>
    </div>
    <div
      class="d-flex flex-column justify-content-center align-items-center user-profile"
    >
      <div class="profile-status-container">
        <app-profile-picture
          [name]="profileDetails?.name"
          [userData]="profileDetails"
          [font]="'large'"
        >
        </app-profile-picture>
        <img
          *ngIf="
            profileDetails?.isDeactivated === true ||
            profileDetails?.isDeactivated === 'true'
          "
          src="../../../../assets/icons/setting-profile-deactivate.svg"
          class="profile-deactivated-badge"
          alt="Deactivated"
        />
      </div>
      <!-- <img
    *ngIf="getNotExpiredTempRecords?.length > 0"
    src="assets/images/circle-time-red-trimmy.png"
    class="time"
    alt="circle-time-red"
  /> -->
    </div>
  </div>
  <div *ngIf="profileDetails?.isDeactivated" class="pending-deletion-wrapper">
    <span class="pending-deletion-pill">{{
      "PENDING_DELETION" | translate
    }}</span>
  </div>
  <div
    *ngIf="
      profileDetails?.invitationPending === 'true' &&
      loginUser?.userType === 'Property Manager Admin'
    "
  >
    <div
      class="px-4 mx-3 pt-4 mb-2"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-top: 35px;
      "
    >
      <img
        src="assets/svg/invitation-pending.svg"
        alt="Invitation Pending"
        title="Invitation Pending"
        style="margin-right: 8px"
      />
      <span
        style="
          font-weight: 700;
          font-style: italic;
          color: #d90615;
          font-size: 13px;
          font-family: 'Opensans';
        "
      >
        {{ "Pending" | translate }}
      </span>
    </div>
  </div>
  <div class="container user-detail px-4 mx-3 pt-4 mb-2">
    <div
      *ngIf="
        profileDetails?.invitationPending === 'true' &&
        loginUser?.userType === 'Property Manager Admin'
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          color: #333;
          font-size: 14px;
          max-width: 768px;
          width: 100%;
        "
      >
        <div class="icon-wrapper">
          <img
            src="assets/svg/resend-invite-ellipse.svg"
            class="ellipse"
            alt="Ellipse"
          />
          <img src="assets/svg/ico-alert-red.svg" class="alert" alt="Alert" />
        </div>

        <div class="ml-2 info-container">
          <span class="info-text">
            {{ "ACCOUNT_NOT_ACTIVATED" | translate }}
          </span>
          <br />
          <button (click)="navigateToResendInvitation()" class="resend-link">
            {{ "Resend_Invitaion" | translate }}
          </button>
        </div>
      </div>
    </div>
    <div
      *ngIf="profileDetails?.isDeactivated"
      class="deactivation-warning-block"
    >
      <div class="deactivation-warning-row">
        <div class="icon-wrapper">
          <img
            src="assets/svg/resend-invite-ellipse.svg"
            class="ellipse"
            alt="Ellipse"
          />
          <img src="assets/svg/ico-alert-red.svg" class="alert" alt="Alert" />
        </div>
        <div class="deactivation-warning-text">
          <span>
            {{
              "ACCOUNT_SCHEDULED_DELETION"
                | translate : { date: formattedAutoDeactivationDate }
            }}
          </span>
          <br />
          <span
            class="review-request-link"
            (click)="navigateToPendingDeletion()"
          >
            {{ "REVIEW_REQUEST" | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="child-container">
      <form
        *ngIf="profileDetails"
        [formGroup]="formGroup"
        class="mt-2 pt-2"
        (ngSubmit)="submit()"
      >
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "NAME" | translate }}</div>
                <div
                  class="col-5 selected-value ml-auto text-right text-height mt-1"
                >
                  <p>
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ formInstance?.name?.value }}
                    </app-with-tooltip>
                  </p>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'NAME' | translate"
                formControlName="name"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance middle"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "PHONE_NUMBER" | translate }}</div>
                <div class="selected-value ml-auto text-right">
                  <p>{{ formInstance?.phone?.value }}</p>
                </div>
                <div
                  *ngIf="
                    profileDetails?.invitationPending === 'true' &&
                    (loginUser?.userType === 'Property Manager Admin' ||
                      loginUser?.userType === 'Property Manager User')
                  "
                  class="btn-list edit-phone-wrapper"
                >
                  <button
                    mat-icon-button
                    type="button"
                    class="text-right edit-phone-btn"
                    tabindex="-1"
                    (click)="navigateToEditPhone()"
                  >
                    <img
                      src="assets/svg/ico-edit.svg"
                      alt="edit phone"
                      class="edit-icon"
                    />
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'SMALL_PHONE' | translate"
                formControlName="phone"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="group-container mb-1">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance last"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title">{{ "ACCESS_DETAIL_EMAIL" | translate }}</div>
                <div class="email ml-auto text-right">
                  <p>{{ formInstance?.email?.value }}</p>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'SMALL_EMAIL' | translate"
                formControlName="email"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-4 mb-3">
          <div class="col-7 heading pl-1">
            {{ "ACCESS_ACTIVITY" | translate }}
          </div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first"
            >
              <div class="d-flex justify-content-between list-box pb-3">
                <div class="title">
                  <img class="mr-2 ml-1" [src]="FORM_ICONS.USER_TYPE" />
                  {{ "USER_TYPE" | translate }}
                </div>
                <div
                  class="selected-value ml-auto text-right align-self-center"
                >
                  <p class="m-0">
                    {{ formInstance?.userType?.value | translate }}
                  </p>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'USER_TYPE' | translate"
                formControlName="userType"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_USER
                    ? null
                    : navigateToUserGroups()
                "
              >
                <div class="title col-4 pt-0 align-self-center">
                  <img class="mr-1" [src]="FORM_ICONS.USER_GROUP" />
                  {{ "GROUP" | translate }}
                </div>

                <ng-container
                  *ngIf="
                    formInstance?.userType?.value ===
                      CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                      formInstance?.userType?.value ===
                        CONSTANTS.PROPERTY_MANAGER_USER;
                    else elseRoleMismatchGroup
                  "
                >
                  <!-- Content to be shown when the condition is true -->
                  <div
                    class="selected-value ml-auto text-right align-self-center"
                  >
                    <p>{{ "ALL_ACCESS" | translate }}</p>
                  </div>
                </ng-container>

                <ng-template #elseRoleMismatchGroup>
                  <!-- Content to be shown when the condition is false -->
                  <div
                    class="selected-value ml-auto mt-1 text-right col-6 pt-0 align-self-center"
                  >
                    <span class="selected-value-text text-height">
                      <app-with-tooltip [showHelpCursor]="true">
                        {{ formInstance?.userGroups?.value }}
                      </app-with-tooltip>
                    </span>
                  </div>
                  <div class="btn-list mt-1">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="phone"
                      class="text-right"
                      tabindex="-1"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </div>
              <input
                matInput
                [placeholder]="'USER_GROUPS' | translate"
                formControlName="userGroups"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                  formInstance?.userType?.value ===
                    CONSTANTS.PROPERTY_MANAGER_USER
                    ? null
                    : navigateToUserAccess()
                "
              >
                <div class="title ml-1">
                  <img class="mr-3" [src]="FORM_ICONS.USER_ACCESS" />
                  {{ "ACCESS" | translate }}
                </div>

                <ng-container
                  *ngIf="
                    formInstance?.userType?.value ===
                      CONSTANTS.PROPERTY_MANAGER_ADMIN ||
                      formInstance?.userType?.value ===
                        CONSTANTS.PROPERTY_MANAGER_USER;
                    else elseRoleMismatch
                  "
                >
                  <!-- Content to be shown when the condition is true -->
                  <div class="selected-value ml-auto text-right">
                    <p>{{ "ALL_ACCESS" | translate }}</p>
                  </div>
                </ng-container>

                <ng-template #elseRoleMismatch>
                  <!-- Content to be shown when the condition is false -->
                  <div class="selected-value ml-auto text-right">
                    <p>
                      {{ formInstance?.userAccess?.value }}
                    </p>
                  </div>
                  <div class="btn-list">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="phone"
                      class="text-right"
                      tabindex="-1"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </ng-template>
              </div>
              <input
                matInput
                [placeholder]="'ACCESS' | translate"
                formControlName="userAccess"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance last pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="navigateToUserActivity()"
              >
                <div class="title">
                  <img class="mr-2" [src]="FORM_ICONS.USER_ACTIVITY" />
                  {{ "USER_ACTIVITY" | translate }}
                </div>
                <div class="last-activity ml-auto text-right">
                  <p>
                    {{ formInstance?.userActivity?.value || "" }}
                  </p>
                </div>
                <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="phone"
                    class="text-right"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'USER_ACTIVITY' | translate"
                formControlName="userActivity"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-4 mb-3">
          <div class="col-7 heading pl-1">{{ "CREDENTIALS" | translate }}</div>
        </div>
        <!-- In MPC-9832 jamal comment hide for now mobile credentials -->
        <!-- <div class="group-container">
          <div
            class="form-group row form-container slide-toggle-primary first pointer-cursor"
          >
            <div class="col-10 pt-1">
              <mat-label class="title">{{
                LANG_CONST.MOBILE_CREDENTIAL
              }}</mat-label>
            </div>
            <div class="col-2 text-right pr-1">
              <mat-slide-toggle
                class="mat-toggle"
                color="primary"
                formControlName="mobileCredential"
                (change)="changeMobileCredentials($event)"
              >
              </mat-slide-toggle>
            </div>
          </div>
        </div> -->

        <div class="group-container">
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance rounded pointer-cursor"
            >
              <div
                class="d-flex justify-content-between list-box"
                (click)="navigateToPhysicalCredentials()"
              >
                <div class="title pl-1">
                  <img class="mr-2" [src]="FORM_ICONS.PHYSICAL_CREDENTIALS" />
                  {{ "PHYSICAL_CREDENTIALS" | translate }}
                </div>
                <div class="selected-value ml-auto text-right">
                  <p>
                    {{ formInstance?.cardCredential?.value }}
                  </p>
                </div>
                <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="phone"
                    class="text-right"
                    tabindex="-1"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'PHYSICAL_CREDENTIALS' | translate"
                formControlName="cardCredential"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>
      </form>
      <div
        class="d-flex flex-row justify-content-center align-items-center d-none"
      >
        <ng-container
          *sameUserIdControl="{
            userId: profileDetails?.email,
            hide: true,
            hideSameAndLowerRoles: CONSTANTS.PROPERTY_MANAGER_USER,
            currentRole: profileDetails?.userType
          }"
        >
          <p
            class="remove-btn mt-2 ml-2 pt-2 mb-3"
            (click)="removeUser()"
            type="button"
          >
            <img src="assets/svg/ico-close-circle-outline.svg" />
            {{ "REMOVE_USER_LABEL" | translate }}
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</div>
